module.exports = __webpack_public_path__ + "img/UT logo full.af34fb26.jpg";